window.$ = window.jQuery = require('jquery');
function DropDown(el) {
    this.dd = el;
    this.placeholder = this.dd.children('span');
    this.opts = this.dd.find('ul.dropdown > li');
    this.val = '';
    this.index = -1;
    this.initEvents();
}
DropDown.prototype = {
    initEvents: function () {
        var obj = this;

        obj.dd.on('click', function (event) {
            $(this).toggleClass('active');
            return false;
        });

        obj.opts.on('click', function () {
            var opt = $(this);
           
            obj.dd.find('li').removeClass('selected');

            opt.addClass('selected');


            if (!obj.dd.hasClass('static-dr')) {
                obj.val = opt.html();
                obj.index = opt.index();
                obj.placeholder.html(obj.val);
            }
                        
            obj.dd.find(".selected-id").val(Number(opt.find(".data-item").attr("data-item-id")));
            if (obj.dd.attr('id') == "dd-status" || obj.dd.data('dd') === "dd-list-radio") {
                // obj.dd.find(".selected-text").val(opt.text().trim().toLowerCase().split(/[ ,]+/).join('_'));
                obj.dd.find(".selected-value").find('input:radio').prop('checked', true);
            } else {
                obj.dd.find(".selected-text").val(opt.text().trim());
            }

            obj.dd.closest('.input-group').removeClass('error');

        });
    },
    getValue: function () {
        return this.val;
    },
    getIndex: function () {
        return this.index;
    }
}


$(document).click(function () {
    // all dropdowns
    $('.cs-dropdown').removeClass('active');
});


export default DropDown;
